import React from "react";
import CardHeader from "./card-header";

interface InsightsHeaderProps {
  name?: string;
  timeframe?: string;
  subtitle?: string;
  showApiCall?: boolean;
  onApiCallToggle?: () => void;
}

export default function InsightsHeader({
  name,
  timeframe,
  subtitle,
  showApiCall,
  onApiCallToggle,
}: InsightsHeaderProps) {
  // Use custom subtitle if provided, otherwise fall back to default format
  const displaySubtitle =
    subtitle ||
    `Here are ${
      name || "the company"
    }'s insights for the ${timeframe} timeframe.`;

  return (
    <CardHeader
      title="Insights"
      subtitle={displaySubtitle}
      showApiCall={showApiCall}
      onApiCallToggle={onApiCallToggle}
      showApiToggle={!!onApiCallToggle}
    />
  );
}
